import api from "@/services/api";

export interface PagBankStatusResponse {
  connected: boolean;
  pagbankConnect: boolean;
}

class GetPagBankStatus {
  execute = async (franchiseId?: string) => {
    const params = franchiseId ? { franchise_id: franchiseId } : undefined;
    const response = await api().get("/franchises/pagbank-status", { params });
    return response.data as PagBankStatusResponse;
  };
}

export { GetPagBankStatus };
